import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

const TrustedVoiceSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const images = [
    `/images/interviewed/WFAA.webp`,
    `/images/interviewed/NBC5.webp`,
    `/images/interviewed/Ksat12.webp`,
    `/images/interviewed/CBSAustin.webp`,
    `/images/interviewed/Kens5.webp`,
    `/images/interviewed/News4sa.webp`,
    `/images/interviewed/SAlive.webp`,
    `/images/interviewed/KXAN.webp`,
    `/images/interviewed/KHOU.webp`,
  ];

  return (
    <div className="bg-white py-12 px-4 text-center relative">
      <div className="max-w-[1300px] mx-auto">
        <h2 className="text-xl lg:text-3xl text-[#2C6BB3] font-bold mb-10">
          Trusted voice in the <br className="sm:hidden" />
          industry:
        </h2>

        <div className="relative w-full">
          <Swiper
            pagination={{
              clickable: true,
              el: ".trusted-swiper-pagination",
              renderBullet: function (index, className) {
                return (
                  '<span class="!h-[7px] !w-[7px] rounded-full m-2 top-0 right-0 !mr-4 !bg-[#82A6D0] ' +
                  className +
                  '"></span>'
                );
              },
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            }}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
            }}
            loop={true}
            speed={600}
            modules={[Pagination, Autoplay, Navigation]}
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              1024: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
            }}
          >
            {images.map((url, index) => (
              <SwiperSlide key={index}>
                <img
                  src={url}
                  alt={`Logo ${index}`}
                  className="w-[186px] mx-auto"
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            ref={prevRef}
            className="absolute left-[-16px] top-1/2 -translate-y-1/2 z-50 lg:hidden"
          >
            <img src="/images/slider-arrow-left.png" alt="Arrow" />
          </button>
          <button
            ref={nextRef}
            className="absolute right-[-16px] top-1/2 -translate-y-1/2 z-50 lg:hidden"
          >
            <img src="/images/slider-arrow-right.png" alt="Arrow" />
          </button>
        </div>

        <div className="trusted-swiper-pagination flex justify-center mt-4" />

        <p className="text-[#2C6BB3] text-base lg:text-xl font-semibold max-lg:max-w-xl mx-auto mt-8">
          Local Texas news outlets often turn to us not just for tips, but
          because we deliver the most effective debt consolidation solutions
          available, backed by experience and proven results.
        </p>
      </div>
    </div>
  );
};

export default TrustedVoiceSlider;
